export default (theme) => ({
  itemsList: {
    listStyle: 'none',
    display: 'flex',
    flexWrap: 'wrap',
    marginLeft: '0',
    marginBottom: '0',
  },
})